
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const init = () => {
    var $component = $('.c-editions');
    if (!$component.length) return;

    var initialIndex = parseInt($component.find('.swiper').attr('data-initial-index'), 10);
    var next = $component.find('.swiper-button-next')[0];
    var prev = $component.find('.swiper-button-prev')[0];
    var swiper = new Swiper($component.find('.swiper-container')[0], {
        modules: [Navigation, Pagination],
        pagination: {
            clickable: true
        },
        navigation: {
            nextEl: next,
            prevEl: prev
        },
        lazy: false,
        preloadImages: false,
        loop: false,
        slidesPerView: 'auto',
        initialSlide: initialIndex,
        init: false,
    });

    // Function to update navigation state for editions swiper
    function updateEditionsNavigationState() {
        const canSlidePrev = swiper.allowSlidePrev && !swiper.isBeginning;
        const canSlideNext = swiper.allowSlideNext && !swiper.isEnd;

        // Update navigation buttons
        if (swiper.navigation && swiper.navigation.nextEl) {
            const $nextBtn = $(swiper.navigation.nextEl);
            $nextBtn.prop('disabled', !canSlideNext);
            $nextBtn.toggleClass('swiper-button-disabled', !canSlideNext);
        }
        
        if (swiper.navigation && swiper.navigation.prevEl) {
            const $prevBtn = $(swiper.navigation.prevEl);
            $prevBtn.prop('disabled', !canSlidePrev);
            $prevBtn.toggleClass('swiper-button-disabled', !canSlidePrev);
        }


    }

    swiper.on('init', function() { 
        var $selected = $(swiper.slides[initialIndex]);
        $selected.find('.c-editions__edition').addClass('is-selected');
        swiper.slideTo(initialIndex);
        
        // Update navigation state after initialization
        setTimeout(updateEditionsNavigationState, 100);
    });

    // Add event listeners to update navigation state
    swiper.on('slideChange', updateEditionsNavigationState);
    swiper.on('reachBeginning', updateEditionsNavigationState);
    swiper.on('reachEnd', updateEditionsNavigationState);
    swiper.on('resize', updateEditionsNavigationState);
    swiper.on('slideChangeTransitionStart', updateEditionsNavigationState);
    swiper.on('slideChangeTransitionEnd', updateEditionsNavigationState);
    swiper.on('fromEdge', updateEditionsNavigationState);
    swiper.on('toEdge', updateEditionsNavigationState);
    swiper.on('update', updateEditionsNavigationState);

    swiper.init();
    
    $component.on('click', '.swiper-slide > a', function(e) {
        var clickedIndex = $(this).parent().index();
        var $editions = $component.find('.swiper-slide .c-editions__edition');
        $editions.removeClass('is-selected');

        var $selectedEdition = $editions.eq(clickedIndex);
        $selectedEdition.addClass('is-selected');

        //swiper.slideTo(clickedIndex);
    });

    // Debug function for editions navigation
    window.testEditionsNavigation = function() {
        // Debug function for testing editions navigation
        // This function can be used to inspect editions swiper state in the console
    };

}

export default init;
